import { render } from "./DashboardCard.vue?vue&type=template&id=427d3994&scoped=true"
import script from "./DashboardCard.vue?vue&type=script&lang=ts"
export * from "./DashboardCard.vue?vue&type=script&lang=ts"

import "./DashboardCard.vue?vue&type=style&index=0&id=427d3994&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-427d3994"

export default script